import { useMemo } from 'react'
import zipcodes from 'zipcodes'
import { useLocations, useNearbyLocations } from '@/api/enrollment-api'
import { getZipFromStorage } from '../storage'
import { toLocationOption } from '../types'

export function useScheduleAppointmentLocations() {
  const zip = getZipFromStorage()
  const zipInfo = zip ? zipcodes.lookup(zip) : null
  const latitude = zipInfo?.latitude ?? null
  const longitude = zipInfo?.longitude ?? null

  const { data: nearbyLocations, isLoading: locationsLoading } = useNearbyLocations(
    latitude,
    longitude
  )
  const { data: allLocations, isLoading: allLocationsLoading } = useLocations()

  const nearbyBranchLocations = useMemo(
    () => (nearbyLocations ?? []).map(({ location }) => location),
    [nearbyLocations]
  )
  const allBranchLocations = useMemo(
    () => (allLocations ?? []).filter(location => location.active),
    [allLocations]
  )
  const branchLocations =
    nearbyBranchLocations.length > 0 ? nearbyBranchLocations : allBranchLocations
  const locationOptions = useMemo(() => branchLocations.map(toLocationOption), [branchLocations])
  const branchesLoading =
    locationsLoading || (nearbyBranchLocations.length === 0 && allLocationsLoading)

  return {
    branchLocations,
    branchesLoading,
    locationOptions
  }
}
